import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import { get } from 'lodash';
import axios from 'axios';
import Router from 'next/router';
import styled from 'styled-components';
import ReCAPTCHA from "react-google-recaptcha";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { TextField, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import Text from '../../../components/typography'
import { theme } from '../../../themes/default-theme';
import Modal from '../../../components/ui/Modal';
import isEmail from 'validator/lib/isEmail';
import Checkbox from '../../forms/Checkbox';
import Cta from '../Cta';
import { ReactSVG } from 'react-svg';
import PlusIcon from '../../../../src/assets/icons/new-plus-icon.svg';
import { setSavedData } from '../../methods/setLocalStorage';

const MailSocialContainer = styled.div`
    text-align: center;
    ${theme.breakpoints.up('md')} {
        h4 {
            margin-bottom: 15px;
            line-height: 24px;
            font-size: 20px;
            + div {
                margin-bottom: 19px;
                max-width: 400px;
                margin-left: auto;
                margin-right: auto;
            }
        }
    }
    ${theme.breakpoints.down('sm')} {
        h4 {
            margin-bottom: 15px;
            font-size: 16px;
            + div {
                margin-bottom: 15px;
            }
        }

    }
`
const FormItem = styled.div`
  display: block;
  position: relative;
  margin:${props => props.margin === 'none' ? `0` : `0 0 20px`};
  width: 100%;
  text-align: left;
  &:nth-child(3), &:nth-child(5) {
    // padding-bottom 19px;
    // border-bottom: 1px solid ${theme.palette.middleGrey};
  }
  &:nth-child(3) {
    fieldset {
        border-color: ${theme.palette.middleGrey}!important;
      }
  }
  &:last-child {
    margin-top: 38px;
    margin-bottom: 0;
    a {
        font-weight: 700;
    }
  }
  ${props => props.display === 0 && `
    display: none;
  `}
  label {
    align-items: flex-start;
  }
  input {
    color: #758094;
  }
  span {
    color: #758094;
    padding-top: 0;
    padding-bottom: 0;
  }
  span > a {
    color: #758094;
    padding-top: 0;
    text-decoration: underline;
  }
  p {
    font-size: 12px;
  }
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`
const RemoveField = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  a {
    font-weight: 700;
    line-height: 21px;
    text-transform: uppercase;
    cursor: pointer;
    ${theme.breakpoints.up('md')} {
        font-size: 15px;
    }
    ${theme.breakpoints.down('sm')} {
        font-size: 14px;
    }   
  }
`

const EmailAppend = styled.div`
  margin-bottom: 19px;
  padding-bottom 15px;
  border-bottom: 1px solid ${theme.palette.middleGrey};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  a {
    font-weight: 700;
    line-height: 21px;
    text-transform: uppercase;
    ${theme.breakpoints.up('md')} {
        font-size: 15px;

    }
    ${theme.breakpoints.down('sm')} {
        font-size: 14px;

    }   
  }
`

const NewModelMailPopup = (props) => {
    const {
        mailStatus,
        res,
        buildUrl
    } = props
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);
    const [captchaError, setCaptchaError] = useState(null);
    const defaultValues = {};
    const [googleCaptcha, setGoogleCaptcha] = useState(false);
    const [fieldsFormState, setFieldsFormState] = useState({});
    const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE : process.env.COUNTRY_CODE;
    const country = countryCode === 'AU' ? "Australia" : "New Zealand";
    const { register, handleSubmit, watch, errors, control, formState, setFormState } = useForm({
        defaultValues: {
            emails: [{ email: "" }]
        }
    });
    const { fields, append, remove } = useFieldArray(
        {
            control,
            name: "emails"
        }
    );
    const [open, setOpen] = useState(true);



    const onSubmit = data => {

        const recaptchaValue = recaptchaRef.current.getValue();

        const dealerId = process.env.DEALER_SITE && window.staticly.dealerData.id ? {
            dealer: window.staticly.dealerData.id
        } : (typeof window != 'undefined' && window.localStorage.getItem('dealer')) && JSON.parse(window.localStorage.getItem('dealer'))?.title || ''

        const formData = {
            data: JSON.stringify(data),
            'g-recaptcha-response': googleCaptcha && googleCaptcha,
            seriesName: res?.seriesName ? res.seriesName : null,
            modelName: res?.selectedModel?.name && res.selectedModel.name,
            modelImage: res?.selectedModel?.images.length > 0 ? JSON.stringify(res?.selectedModel?.images[0]) : null,
            floorplanName: res?.selectedModelFloorplan?.activeFloorPlanModel?.name ? res.selectedModelFloorplan.activeFloorPlanModel.name : null,
            floorplanShape: res?.selectedModelFloorplan?.activeConfiguration?.shape ? res.selectedModelFloorplan.activeConfiguration.shape : null,
            floorplanSize: res?.selectedModelFloorplan?.activeConfiguration?.size ? res.selectedModelFloorplan.activeConfiguration.size : null,
            floorplanImage: res?.selectedModelFloorplan?.activeConfiguration?.image ? JSON.stringify(res.selectedModelFloorplan.activeConfiguration.image) : null,
            specifications: res?.selectedModelFloorplan?.activeFloorPlanModel?.floorplan?.specsFeatures?.modal?.sections ? JSON.stringify(res.selectedModelFloorplan.activeFloorPlanModel.floorplan.specsFeatures.modal.sections) : null,
            decors: res?.selectedInteriorDecors?.activeDecors?.length > 0 && res?.selectedInteriorDecors?.activeDecors[0]?.length > 0 ? JSON.stringify(res.selectedInteriorDecors.activeDecors[0]) : null,
            options: res?.selectedOptions?.length > 0 ? JSON.stringify(res.selectedOptions.map((item) => item.title && item.title)) : null,
            buildUrl: buildUrl ? buildUrl : '',
            form_id: 'build_and_price',
            dealerId: dealerId && JSON.stringify(dealerId)
        }

        if ((res && Object.values(res).length > 0) && (res.selectedModel && Object.values(res.selectedModel).length > 0) && (res.selectedModelFloorplan && Object.values(res.selectedModelFloorplan).length > 0) && res.seriesName && (googleCaptcha && recaptchaValue.length > 0) && (Object.keys(errors).length === 0)) {            
            let formattedData = {};
            let bodyFormData = new FormData();

            Object.keys(formData).forEach(key => {
                // For all others
                // console.log('other', formData[key]);
                formattedData[key] = formData[key] ? formData[key].toString() : '';
                bodyFormData.append(key, formData[key] ? formData[key].toString() : '');

            });


            const userData = {
                userEmails: formData?.data && JSON.parse(formData.data) && JSON.parse(formData.data).emails?.length > 0 && JSON.parse(formData.data).emails            
            }

            setCaptchaError(null);

            const endpoint = process.env.STATICLY_FORMS_API_ENDPOINT;

            setSending(true);


            // axios.post(endpoint, formData)
            axios({
                method: 'post',
                url: endpoint,
                data: bodyFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    console.log('response:', response);
                    Router.push(`${props.thankyouPageUrl && props.thankyouPageUrl}`);
                    if(userData) {
                      setSavedData(
                        'modelSummaryPageUserData',
                        JSON.stringify(
                          userData
                        ),
                        3600 // 1 hour
                      );
                    }
                })
                .catch((error) => {
                    console.log('Form error: ', error);
                    setError('Something went wrong. Please try again later.');
                    setSending(false);
                });

        } else {
            setCaptchaError('Google captcha not complete');
            setSending(false)
        }
    }
    const recaptchaRef = useRef();
    const dealerTitle = process.browser && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"

    const requiredRules = { required: true }

    // Methods Start

    const useStyles = makeStyles(theme => ({
        modalOverlay: {
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
            }
        },
        content: {
            position: 'relative',
            zIndex: 1001,
            display: 'inline-block',
            verticalAlign: 'middle',
            width: '100%',
            maxWidth: '544px',
            margin: 'auto',
            background: '#F3F4F7',
            [theme.breakpoints.up('md')]: {
                padding: '37px 46px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '20px'
            }
        },
        modalInner: {
            width: '100%',
            display: 'inline-block',
            maxWidth: 1254,
        },
        modalClose: {
            top: '20px',
            right: '20px',
            position: 'fixed',

        }
    }));

    const classes = useStyles();

    return (

        <Modal
            isOpen={open}
            onClose={() => {
                setOpen(false);
                mailStatus();
            }
            }
            overlayClassname={classes.modalOverlay}
            innerClassname={classes.modalInner}
            closeClassname={classes.modalClose}
            contentClassname={classes.content}
            backdropBackground={'rgba(46, 50, 56, 0.8)'}
            iconVividBlue={true}
        >
            <MailSocialContainer>
                <Text variant="h4" weight={800} align={'center'} uppercase>Email</Text>
                <Text variant="body1" align={'center'}>Send the URL of your Jayco build via email.</Text>
                <form id='build_and_price' noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} >
                    {fields.map((item, index) => {
                        return (
                            <FormItem key={item.id}>
                                {index == 0 ?
                                    <>
                                        <Controller
                                            type="email"
                                            as={TextField}
                                            control={control}
                                            rules={{
                                                ...requiredRules,
                                                type: 'custom',
                                                validate: (e) => isEmail(e)
                                            }}
                                            name={`emails[${index}]email`}
                                            placeholder={'Recipient email*'}
                                            variant="outlined"
                                            error={get(errors, `emails[${index}]email`, false) ? true : false}
                                            fullWidth
                                            defaultValue={`${item.email}`}
                                        />
                                        {get(errors, `emails[${index}]email`, false) && <Error>Please enter a valid email</Error>}
                                    </>
                                    :
                                    <>
                                        <Controller
                                            type="email"
                                            as={TextField}
                                            control={control}

                                            name={`emails[${index}]email`}
                                            placeholder={'Recipient email (Optional)'}
                                            variant="outlined"
                                            error={get(errors, `${index}email`, false) ? true : false}
                                            fullWidth
                                            defaultValue={`${item.email}`}
                                        />
                                        <RemoveField>
                                            <a onClick={() => remove(index)}>
                                                remove
                                            </a>
                                        </RemoveField>
                                    </>
                                }
                            </FormItem>
                        )
                    })}
                    <EmailAppend onClick={() => {
                        append({ email: "" });
                    }}>
                        <ReactSVG src={PlusIcon} />
                        <a>
                            Add Additional Recipient
                        </a>
                    </EmailAppend>
                    <FormItem>
                        <Controller
                            as={TextField}
                            control={control}
                            type="textarea"
                            name={'enquiry'}
                            placeholder={'Your Message (Optional)'}
                            variant="outlined"
                            error={get(errors, `[enquiry]`, false) ? true : false}
                            fullWidth
                            defaultValue={''}
                            multiline={true}
                            minRows={5}
                        />
                    </FormItem>
                    <FormItem>
                        <Controller
                            as={Checkbox}
                            name="privacy"
                            type="checkbox"
                            control={control}
                            label={`I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <br/><a href="/privacy" target="_blank">Privacy Policy</a>*`}
                            error={get(errors, `[privacy]`, false) ? true : false}
                            defaultValue={false}
                            rules={{
                                required: true,
                                type: 'custom'
                            }}
                        />
                        {get(errors, `[privacy]`, false) && <Error>This field is required</Error>}
                    </FormItem>
                    {process.env.GOOGLE_RECAPTCHA_SITE_KEY &&
                        <FormItem>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                sitekey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}
                                onChange={setGoogleCaptcha}
                            />
                            {!googleCaptcha && captchaError &&
                                <Error>{captchaError}</Error>
                            }
                            {error &&
                                <Error>{error}</Error>
                            }
                        </FormItem>
                    }
                    <FormItem>
                        <Cta type="submit"  >{sending ? 'Sending...' : 'Send'}</Cta>
                    </FormItem>
                </form>
            </MailSocialContainer>
        </Modal>

    )
}

NewModelMailPopup.propTypes = {
    mailStatus: propTypes.func,
    res: propTypes.object,
    buildUrl: propTypes.string
}

NewModelMailPopup.defaultProps = {
    mailStatus: () => { },
    res: null,
    buildUrl: null
}

export default NewModelMailPopup